import axios from "axios";
import { PROCESS_AUTOMATION_SERVICE_URL } from "../Common/Constant/API";
import { commonRequestHeaders } from "../Common/request/headers";
import { getToken } from "../Utils/JWTTokenUtil";

const getHeaders = () => {
  const token = getToken();
  return {
    ...commonRequestHeaders(),
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    "Content-Type": "application/json",
  };
};

const migrationUrl = `${PROCESS_AUTOMATION_SERVICE_URL}/api/v1/github-configuration-migration`;

export const fetchGitHubConfigurationMigrationRepositories = async () => {
  const response = await axios.get(
    `${migrationUrl}/repositories`,
    { headers: getHeaders() }
  );
  return response.data;
};

export const previewGitHubConfigurationMigration = async (repositories) => {
  const response = await axios.post(
    `${migrationUrl}/preview`,
    { repositories },
    { headers: getHeaders() }
  );
  return response.data;
};

export const createGitHubConfigurationMigrationPullRequests = async (repositories) => {
  const response = await axios.post(
    `${migrationUrl}/pull-requests`,
    { repositories },
    { headers: getHeaders() }
  );
  return response.data;
};
